import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { QUICK_ORDER } from 'src/app/service/tooltip-icon/tooltip-icon.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { NotifyMeModule } from '../../product/notify-me/notify-me.module';
import { TooltipIconModule } from '../../tooltip-icon/tooltip-icon.module';
import { ItemCounterModule } from '../item-counter/item-counter.module';
import { QuickOrderClearModalComponent } from './quick-order-clear-modal/quick-order-clear-modal.component';
import { QuickOrderSubmitModalComponent } from './quick-order-submit-modal/quick-order-sumbit-modal.component';
import { QuickOrderComponent } from './quick-order.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    MatIconModule,
    IconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    ReactiveFormsModule,
    FormsModule,
    MediaModule,
    RouterModule,
    SharedModule,
    UrlModule,
    ItemCounterModule,
    TooltipIconModule,
    SharedModule,
    NotifyMeModule,
    QuickOrderComponent,
    QuickOrderClearModalComponent,
    QuickOrderSubmitModalComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      [QUICK_ORDER]: {
        module: () => import('@spartacus/cart/quick-order').then((m) => m.QuickOrderModule),
      },
      cmsComponents: {
        QuickOrderFormSectionComponent: {
          component: QuickOrderComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
    provideConfig({
      ...LaunchDialogModalLayoutConfig.QuickOrder,
    }),
    provideConfig({
      ...LaunchDialogModalLayoutConfig.BackOrderCart,
    }),
  ],
  exports: [QuickOrderComponent, QuickOrderClearModalComponent, QuickOrderSubmitModalComponent],
})
export class QuickOrderModule {}
